import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash'
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../hooks/hooks";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { Swiper, SwiperSlide } from "swiper/react";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import * as R from "ramda"
import { selectEventsCreatedItem, selectEventsListItems } from "../../redux/event/events/selector";
import { events } from "../../redux/event/events/action";
import ProgramCard from "./events-cards.component";
import { tickets } from "../../redux/tickets/action";
import { selectTicketsListItems } from "../../redux/tickets/selector";
import { eventSubscriptions } from "../../redux/event-subscriptions/action";



export default function Events() {
  const dispatch = useAppDispatch();
  const [topics, setTopics] = useState<any>([]);
  const statesItems = storePersist?.get("states")?.current?.items;
  const countriesItems = storePersist?.get("countries")?.current?.items;
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const Eventslist = useSelector(selectEventsListItems);
  const Ticketslist = useSelector(selectTicketsListItems)
  const listevents = useSelector(selectEventsCreatedItem)
  const [selectedEvents, setSelectedEvents] = useState<any>({


  });
  const resetForm = () => {
    setSelectedEvents({
      Login: {
        Phone: "",
        Email: ""
      },
      UserProfile: {
        FirstName: "",
        LastName: "",
        PersonTitle: ""
      },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
      },
      Account: {
        IsPersonAccount: true,
        Name: "",
        TypeId: ""
      },
      PrimaryAddress: {
        address1: "",
        address2: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      }
    });
  };
  useEffect(() => {
    if (listevents?.isSuccess) {
      dispatch(eventSubscriptions.resetAction({ actionType: 'create' }))
      dispatch(eventSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/event/bookings`,
        entity: 'subscription',
        jsonData: {
          Records: [
            {

            "Email":selectedEvents?.Login?.Email,
      "PhoneNumber":selectedEvents?.Login?.Phone,
              "OwnerType": "Events",
              "EventTicketId": selectedEvents?.EventTicketId,
              "EventId": selectedEvents?.EventId,
              "Quantity": selectedEvents?.Quantity,
              "IsExistingUser": selectedEvents?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();

      dispatch(events.resetAction({ actionType: 'create' }))
    }
  }, [listevents]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      "Login": {
        "Phone": selectedEvents?.Login?.Phone,
        "Email": selectedEvents?.Login?.Email,
      },

      "UserProfile": {
        "FirstName": selectedEvents?.UserProfile?.FirstName,
        "LastName": "",
        "PersonTitle": ""
      },
      "ONEUserInfo": {
        "Biography": null,
        "PhotoUrl": null,
        "IsONEUserVerified": true,
        "StartupName": selectedEvents?.ONEUserInfo?.StartupName,
        "YearsInOperation": "",
        "IsTechFirstInnovation": true,
        "StageOfTheStartup": selectedEvents?.ONEUserInfo?.StageOfTheStartup,
        "Sector": selectedEvents?.ONEUserInfo?.Sector,
        "WebsiteLink": selectedEvents?.PrimaryAddress?.WebsiteLink,
        "utm_source": null,
        "utm_medium": null,
        "utm_campaign": null,
        "utm_term": null,
        "utm_content": null
      },

      "Account": {
        "IsPersonAccount": true,
        "Name": "ONE User 001",
        "TypeId": 440
      },

      "PrimaryAddress": {
        "address1": selectedEvents?.PrimaryAddress?.address1,
        "address2": selectedEvents?.PrimaryAddress?.address2,
        "city": selectedEvents?.PrimaryAddress?.city,
        "CountryId": selectedEvents?.PrimaryAddress?.CountryId,
        "StateProvinceId": selectedEvents?.PrimaryAddress?.StateProvinceId,
        "ZipPostalCode": selectedEvents?.PrimaryAddress?.ZipPostalCode,
      }




    }
    if (!selectedEvents?.IsExistingUser) {
      await dispatch(events.resetAction({ actionType: 'create' }))
      await dispatch(events.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'eventsSubscriptions',
        jsonData: {
          records: [
            data
          ]
        }
      }))


      await resetForm();

    } else {
      dispatch(eventSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/event/bookings`,
        entity: 'subscription',
        jsonData: {
          Records: [
            {
             "Email": selectedEvents?.Email,
              "PhoneNumber": selectedEvents?.Phone,
              "OwnerType": "Events",
              "EventTicketId": selectedEvents?.EventTicketId,
              "EventId": selectedEvents?.EventId,
              "Quantity": selectedEvents?.Quantity,
              "IsExistingUser": selectedEvents?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();
    }
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedEvents({ ...selectedEvents, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedEvents({ ...selectedEvents, [field]: event })

  }

  const dummyData = [{
    id: 1,
    Name: "Events Name 1"
  },
  {
    id: 2,
    Name: "Events Name 2"
  }, {
    id: 3,
    Name: "Events Name 3"
  }, {
    id: 4,
    Name: "Events Name 4"
  }, {
    id: 5,
    Name: "Events Name 5"
  }]

  const dataToRender = Eventslist?.result?.items?.length > 0
    ? Eventslist.result.items
    : dummyData;

  useEffect(() => {
    dispatch(events.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,
      entity: 'events',
      jsonData: {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],

      }

    }));
  }, []);

  useEffect(() => {
    dispatch(tickets.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
      entity: 'tickets',
      jsonData: {
        Filters: [
          {
            FieldName: 'EventId',
            FilterOperatorId: 1,
            FieldValue: selectedEvents?.EventId,
            FieldType: 'number'
          }
        ]
      }
    }));
  }, [selectedEvents]);


  useEffect(() => {
    if (Eventslist) {
      setTopics(Eventslist?.result?.items);
    }
  }, [Eventslist])

    const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_EVENT_MAIN_BANNER') : null;
    const banner: any = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../assets/img/events.jpg'))

  const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

  const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

  const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY') : null;

  const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

  const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE') : null;

  const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

  // const banner = require('../../assets/img/events.jpg')
  return (
    <>

      <div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}>
        <div className="flex justify-around items-center p-1 w-full h-[650px] px-10">
          {/* Left side text section */}
          <div className="flex p-2 flex-col justify-between items-center w-[800px]">
            {/* <p className="text-4xl font-normal text-white text-center">{CargoPageBannerData[0]?.title}</p>
                            <p className="text-xl pt-20 text-white text-center">{CargoPageBannerData[0]?.subTitle}</p> */}
            <p className="text-4xl font-normal text-white text-center"></p>
            <p className="text-xl pt-20 text-white text-center"></p>
          </div>

          {/* Right side form section */}
						<div className="w-1/3 flex justify-center items-start mt-20 rounded-2xl bg-white">
            <div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
              <div className="text-2xl text-primary font-bold py-5">Events Booking Form</div>
              <div className=" w-full px-3 font-bold space-y-2">

                <div className=" w-full pt-2">
                  <div className="font-normal ">
                    <input
                      type="checkbox"
                      name="IsExistingUser"
                      checked={selectedEvents?.IsExistingUser || false}
                      onChange={(event) => {
                        handleChange(event.target.checked, 'IsExistingUser');
                      }}
                      className="mr-2 w-4 h-4"
                    />
                    <label htmlFor="IsExistingUser" className="text-base">
                      Are you already registered?
                    </label>
                  </div>
                </div>
                {!selectedEvents?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">

                    <div className=" w-full pt-2">
                      <div className="font-normal ">
                        <input
                          required
                          type="text"
                          name={"FirstName"}
                          placeholder="Name"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'UserProfile.FirstName',
                              selectedEvents?.UserProfile
                            );

                          }}
                          value={selectedEvents?.UserProfile?.FirstName}
                        />
                      </div>
                    </div>


                   

                  </div>
                )}
                {selectedEvents?.IsExistingUser && (
                 <div className="flex flex-col space-y-2">


                    {!selectedEvents?.Email && !selectedEvents?.Phone && (
                      <label className="text-sm text-gray-700 font-medium mb-2">
                        Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                      </label>
                    )}

                    <div className="flex flex-row space-x-2">

                      {!selectedEvents?.Phone && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Email</label>
                            <input
                              required
                              type="email"
                              name="Email"
                              placeholder="Email"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value, 'Email');
                              }}
                              value={selectedEvents?.Email}
                            />
                          </div>
                        </div>
                      )}


                      {!selectedEvents?.Email && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Phone Number</label>
                            <input
                              required
                              maxLength={10}
                              type="text"
                              name="Phone"
                              placeholder="Phone Number"
                              pattern="\d{10}"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value.replace(/\D/g, ''), 'Phone');
                              }}
                              value={selectedEvents?.Phone}
                            />
                            {selectedEvents?.Phone?.length > 0 &&
                              selectedEvents?.Phone?.length < 10 && (
                                <span className="text-red-600 text-xs">
                                  Please enter a valid number.
                                </span>
                              )}
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                )}

                {!selectedEvents?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
 <div className=" w-full pt-2">
                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"Email"}
                          placeholder="Email"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'Login.Email',
                              selectedEvents?.Login
                            );
                          }}
                          value={selectedEvents?.Login?.Email} />
                      </div>
                    </div>
                    <div className=" w-full pt-2">

                      <div className="border-0 font-normal">
                        <input
                          required
                          maxLength={10}
                          type="text"
                          name={"Phone"}
                          placeholder="Phone Number"
                          pattern="\d{10}"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value.replace(/\D/g, ''),
                              'Login.Phone',
                              selectedEvents?.Login
                            );
                          }}
                          value={selectedEvents?.Login?.Phone} />
                        {selectedEvents?.Phone && selectedEvents?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">
                            Please enter a valid number.
                          </span>
                        )}
                      </div>

                    </div>



                  </div>
                )}
                {!selectedEvents?.IsExistingUser && (

                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address1"}
                          placeholder="Building"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address1',
                              selectedEvents?.PrimaryAddress
                            );
                          }}
                          value={selectedEvents?.PrimaryAddress?.address1}

                        />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address2"}
                          placeholder="Locality"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address2',
                              selectedEvents?.PrimaryAddress
                            );
                          }}
                          value={selectedEvents?.PrimaryAddress?.address2}

                        />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedEvents?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"city"}
                          placeholder="City"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.city',
                              selectedEvents?.PrimaryAddress
                            );
                          }}
                          value={selectedEvents?.PrimaryAddress?.city}

                        />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"ZipPostalCode"}
                          placeholder="Pincode"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.ZipPostalCode',
                              selectedEvents?.PrimaryAddress
                            );
                          }}
                          value={selectedEvents?.PrimaryAddress?.ZipPostalCode}
                        />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedEvents?.IsExistingUser && (
                  <div className="flex flex-row space-x-2">

                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="country"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                            selectedEvents?.PrimaryAddress
                          )}
                          value={selectedEvents?.PrimaryAddress?.CountryId || ''}
                        >
                          <option value="" disabled hidden>Select Country</option>

                          {countriesItems.map((country: any) => (
                            <option key={country.Id} value={country.Id}>{country.Name}</option>
                          ))}

                        </select>
                      </div>
                    </div>


                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="StateProvinceId"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                            selectedEvents?.PrimaryAddress
                          )}
                          value={selectedEvents?.PrimaryAddress?.StateProvinceId || ''}
                        >
                          <option value="" disabled hidden>Select State</option>
                          {statesItems?.length > 0 ? (
                            statesItems.map((state, index) => (
                              <option key={index} value={state.Id}>
                                {state.Name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No states available</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                )}



                <div className="flex flex-row space-x-2">
                  <div className="w-full pt-2">
                    <div className="font-normal">
                      <select
                        required
                        name="program"
                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                        onChange={(event) => handleChange(event.target.value, 'EventId')}
                        value={selectedEvents?.EventId || ''}
                      >
                        <option value="" disabled hidden>
                          Select a Events
                        </option>
                        {Eventslist?.result?.items?.length > 0 ? (
                          Eventslist.result.items.map((events, index) => (
                            <option key={index} value={events.EventId}>
                              {events.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No Events available now
                          </option>
                        )}
                      </select>
                    </div>
                  </div>


                </div>
                {selectedEvents?.EventId ?
                  <div className="flex flex-row space-x-2">
                    <div className="w-full pt-2">
                      <div className="font-normal">
                        <select
                          required
                          name="program"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleChange(event.target.value, 'EventTicketId')}
                          value={selectedEvents?.EventTicketId || ''}
                        >
                          <option value="" disabled hidden>
                            Select a Tickets
                          </option>
                          {Ticketslist?.result?.items?.length > 0 ? (
                            Ticketslist.result.items.map((tickets, index) => (
                              <option key={index} value={tickets.EventId}>
                                {tickets.Name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No Tickets available now
                            </option>
                          )}
                        </select>
                      </div>
                    </div>

                     {selectedEvents?.EventTicketId ?
                  <div className=" w-full pt-2">
                    <div className="font-normal ">
                      <input
                        required
                        type="number"
                        name={"Quantity"}
                        placeholder="No of Tickets"
                        className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                        onChange={(event) => {
                          handleChange(
                            event.target.value,
                            'Quantity'
                          );

                        }}
                        value={selectedEvents?.Quantity}
                      />
                    </div>
                  </div> : null

                }
                  </div> : null

                }
               
              </div>
              {/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

								<div className={`${isButtonLoading ? 'bg-primary/70' : 'bg-primary'} px-5 flex w-full flex-row items-center justify-center mt-5 mb-10 rounded-lg`}>
                <div

                  onClick={handleSubmit}
                  className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer"
                >
                  Book Events
                  <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
                    <RotatingLines
                      visible={true}
                      width={'20'}
                      strokeColor="#fff"
                      strokeWidth="6"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div className="flex w-full py-10">
        <div className="swiper p-4 w-full" id="slider5">
          <div className="swiper-wrapper w-full">
            <Swiper
              navigation={{
                nextEl: '.swiper-button-next-ex5',
                prevEl: '.swiper-button-prev-ex5',
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                1536: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
              }}
            >
              {dataToRender.map((item: any, i: any) => {
                return (
                  <SwiperSlide key={i}>
                    <ProgramCard
                      eventsDetails={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </>



  );
}


